Vue.asyncComponent('cms-dashboard', {
    data() {
        return {
            widgets: []
        }
    },
    computed: {
        showWorkspaceSwitch() {
            return this.$userInterfaceHandler.getUserInterface()?.workspace.id === '';
        },
        workspaceLogo() {
            return this.$userInterfaceHandler.getUserInterface()?.workspace.logo ?
                    this.$userInterfaceHandler.getUserInterface()?.workspace.logo:
                    this.$getSetting('assets.logo');
        },
        workspaceTitle() {
            return this.$userInterfaceHandler.getUserInterface()?.workspace.title ?
                    this.$userInterfaceHandler.getUserInterface()?.workspace.title:
                    null;
        },
        baseDashboardUri() {
            return this.$getSetting('paths.baseCms') + '/dashboard';
        }
    },
    methods: {
        async fetchDashboardData() {
            const result = await this.$get(this.baseDashboardUri);
            this.widgets = result.widgets;
        }
    },
    created() {
        if (! this.showWorkspaceSwitch) {
            this.fetchDashboardData();
        }
    }
}, 'cms/pages/cms-dashboard.html');
